import { Skeleton } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import { goalRoute } from '@townsquare/routes/goal-view';

import { goalHighlightsTabResource } from './resources/GoalHighlightsTab';
import { goalViewResource } from './resources/GoalView';
import { goalViewAsideResource } from './resources/GoalViewAside';
import { goalViewHeaderResource } from './resources/GoalViewHeader';

goalRoute.component = Loadable({
  loader: () => import(/* webpackChunkName: "goal-view" */ './components/GoalView'),
  loading: () => null,
});
goalRoute.aside = Loadable({
  loader: () => import(/* webpackChunkName: "goal-view-aside" */ './components/GoalViewAside'),
  loading: () => null,
});
goalRoute.header = Loadable({
  loader: () => import(/* webpackChunkName: "goal-view-header" */ './components/GoalHeaderRefreshed'),
  loading: Skeleton,
});
goalRoute.resources = [goalViewResource, goalViewAsideResource, goalHighlightsTabResource, goalViewHeaderResource];

export const goalViewRoute = goalRoute;
